import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import Modal from '@/components/common/Modal/Modal';
import GlobalSettings from './GlobalSettings';
import styles from './SettingsModal.module.css';

/**
 * SettingsModal Component
 * Modal wrapper for GlobalSettings
 * Opens via route: /modal?mode=settings
 */
const SettingsModal = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (location.pathname === '/modal' && mode === 'settings') {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [location.pathname, mode]);

  const handleClose = () => {
    setIsOpen(false);
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('mode');
    newSearchParams.delete('section');
    navigate(`/?${newSearchParams.toString()}`, { replace: true });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      size="xl"
      title="Global Settings"
      showCloseButton={true}
      className={styles.modal}
    >
      <div className={styles.modalBody}>
        <div className={styles.settingsContent}>
          <GlobalSettings />
        </div>
      </div>
    </Modal>
  );
};

export default SettingsModal;
